
define('ldsh!modules/page_generator/templates/generator_popup_preview', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!-- pseudo HEAD -->\n<!-- default styles/scripts -->\n<link rel="stylesheet" href="' +
((__t = ( base )) == null ? '' : __t) +
'/lpg/public/templates.min.css" />\n';
 if (headScripts) { ;
__p += '\n<script src="' +
((__t = (jQueryURL )) == null ? '' : __t) +
'"></script>\n';
 } ;
__p += '\n\n<!-- element styles -->\n<style type="text/css">\n  ' +
((__t = ( elementStyles )) == null ? '' : __t) +
'\n</style>\n<!-- variant styles -->\n' +
((__t = ( styles )) == null ? '' : __t) +
'\n' +
((__t = ( headScripts )) == null ? '' : __t) +
'\n\n';
 if (googleReCaptchaSiteKey && googleReCaptchaURL) { ;
__p += '\n<script src="' +
((__t = ( googleReCaptchaURL )) == null ? '' : __t) +
'" async defer></script>\n';
 } ;
__p += '\n\n<style>\n  .popup__overlay {\n    visibility: visible;\n    opacity: 1;\n  }\n  #popup' +
((__t = ( stepId )) == null ? '' : __t) +
'.popup__overlay {\n                      background-color: ' +
((__t = ( popupProperties.overlayRGBA )) == null ? '' : __t) +
';\n                    }\n  #popup' +
((__t = ( stepId )) == null ? '' : __t) +
' .popup {\n                      width: ' +
((__t = ( popupProperties.width )) == null ? '' : __t) +
';\n                      height: ' +
((__t = ( popupProperties.height )) == null ? '' : __t) +
';\n                      border-radius: ' +
((__t = ( popupProperties.windowRadius )) == null ? '' : __t) +
'px;\n                      font-family: ' +
((__t = ( popupProperties.fontFamily )) == null ? '' : __t) +
';\n                      background-color: ' +
((__t = ( popupProperties.backgroundColor )) == null ? '' : __t) +
';\n                      color: ' +
((__t = ( popupProperties.fontColor )) == null ? '' : __t) +
';\n                    }\n  #popup' +
((__t = ( stepId )) == null ? '' : __t) +
' .popup a:not(.popup__trigger--close) {\n                      color: ' +
((__t = ( popupProperties.linkColor )) == null ? '' : __t) +
';\n                    }\n</style>\n<!-- /pseudo HEAD -->\n\n<!-- pseudo BODY -->\n<div id="popup' +
((__t = ( stepId )) == null ? '' : __t) +
'" class="popup__overlay">\n  ';
 if (popupProperties.closeOnClickOutside) { ;
__p += '\n  <a class="popup--cancel popup__trigger--close" href="#"></a>\n  ';
 } ;
__p += '\n  <div class="popup ' +
((__t = (popupProperties.windowPosition )) == null ? '' : __t) +
'">\n    <div class="popup__title">\n      <h2>' +
((__t = (popupProperties.title )) == null ? '' : __t) +
'</h2>\n    </div>\n    <a class="popup--close popup__trigger--close" href="#">&times;</a>\n    <div class="popup__content">\n\n      <!-- POPUP CONTENT -->\n\n      <div id="fb-root"></div>\n      <!-- body contents -->\n      <div class="wrapper lpg-page">\n        ' +
((__t = ( content )) == null ? '' : __t) +
'\n      </div>\n\n      ';
 if (isContent) { ;
__p += '\n        <!-- validation summary -->\n        <div class="form-validation-overlay js-lpg-validation" style="display:none">\n          <span class="close"></span>\n          <h2>' +
((__t = ( errorMessage )) == null ? '' : __t) +
'</h2>\n          <ul class="js-lpg-error-list"></ul>\n        </div>\n        <!-- /validation summary -->\n\n        ';
 _.each(externalPublicLibs, function(lib) { ;
__p += '\n          <script src="' +
((__t = ( base )) == null ? '' : __t) +
'/lpg/public/' +
((__t = ( lib )) == null ? '' : __t) +
'.js"></script>\n        ';
 }) ;
__p += '\n\n        ';
 if (linkedinAppId) { ;
__p += '\n          <script type="text/javascript" src="//platform.linkedin.com/in.js">\n            api_key: ' +
((__t = ( linkedinAppId )) == null ? '' : __t) +
'\n              onLoad: LPGRuntime.onLinkedInLogin\n            lang: ' +
((__t = ( isoLanguage )) == null ? '' : __t) +
'\n          </script>\n        ';
 } ;
__p += '\n        <script src="' +
((__t = (jQueryURL )) == null ? '' : __t) +
'"></script>\n        <script src="' +
((__t = ( base )) == null ? '' : __t) +
'/lpg/public/lpg_pub.min.js?v=6"></script>\n        <script type="text/javascript">\n          LPGRuntime.init({\n              lpgIsPreview: false,\n              lpgCookies: ' +
((__t = ( privacy.active )) == null ? '' : __t) +
',\n            errorMessage: "' +
((__t = ( errorMessage )) == null ? '' : __t) +
'",\n            appId: "' +
((__t = ( facebookAppId )) == null ? '' : __t) +
'",\n            idaf: "{{idaf}}"\n          });\n        </script>\n      ';
 } ;
__p += '\n\n      <!-- variant scripts -->\n      ' +
((__t = ( scripts )) == null ? '' : __t) +
'\n\n      <!-- social api scripts for share buttons -->\n      ' +
((__t = ( socialScripts )) == null ? '' : __t) +
'\n      ';
 if (facebookAppId) { ;
__p += '\n      <script id="facebook-jssdk" src="//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.0"></script>\n      ';
 } ;
__p += '\n\n      <!-- /POPUP CONTENT -->\n\n    </div>\n  </div>\n</div>\n<!-- / pseudo BODY -->\n';

}
return __p
};});

